'use strict';

var React = require('react');
var Border = require('../common/Border');
var IconParts = require('../common/IconParts');
var appTypes = require('../../types/appTypes');
var _ = require('underscore');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');

var IconButton = React.createClass({

  _getBorderRadius: function (buttonStyle) {

    switch (buttonStyle) {
      case appTypes.IconButtonStyle.CIRCLE:
        return '50%';
        break;
      case appTypes.IconButtonStyle.RECTANGLE:
        return '0px';
        break;
      case appTypes.IconButtonStyle.ROUND_RECTANGLE:
        return Math.round(8 * (styleHelper.getWidth(this.props) / 64)) + 'px';
        break;
    }
  },

  render: function () {
    var w = styleHelper.getWidth(this.props);
    var borderStyle = {
      borderStyle: styleHelper.getPropertyValue(this.props, propConst.BORDER_VISIBLE) ? 'solid' : 'none',
      borderWidth: w < 48 ? 1 : 2,
      borderRadius: this._getBorderRadius(this.props.buttonStyle),
      boxSizing: 'border-box',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      background : styleHelper.getBackgroundColor(this.props),
      borderColor : styleHelper.getBorderColor(this.props)
    };
    var iconSize = Math.round(w * 0.6);
    var iconPoint = Math.round(w * 0.2);
    var props = _.extend({}, this.props);
    delete props.currentX;
    delete props.currentY;
    delete props.currentW;
    delete props.currentH;
    props.x = props.y = iconPoint;
    props.w = props.h = iconSize;
    props.defaultIcon = 'Gt.png';
    props.color = styleHelper.getPropertyValue(this.props, propConst.ICON_COLOR);

    return (<div style={borderStyle}>
      <IconParts {...props} />
    </div>);
  }
});

module.exports = IconButton;



// WEBPACK FOOTER //
// ./src/views/Components/IconButton.jsx